import React, {Component, PropTypes} from 'react'
import Radium from 'radium'

@Radium
export default class FileDropZone extends Component {
  constructor () {
    super()
    this.state = {
      dragging: false,
      files: []
    }
  }

  static propTypes = {
    label: PropTypes.string.isRequired,
    onDrop: PropTypes.func
  }

  handleDragEnter = event => {
    this.setState({dragging: true})
  }

  handleDragOver = event => {
    event.preventDefault()
  }

  handleDragLeave = event => {
    this.setState({dragging: false})
  }

  handleDrop = event => {
    event.preventDefault()
    this.setState({dragging: false})
    if (event.dataTransfer.files.length > 0) {
      const transferedSvgFiles = Array.from(event.dataTransfer.files).filter(file => file.type === 'image/svg+xml')
      if (transferedSvgFiles.length > 0) {
        this.setState({
          files: this.state.files.concat(transferedSvgFiles)
        })
        if (typeof this.props.onDrop === 'function') this.props.onDrop(event)
      }
    }
  }

  render () {
    return (
      <section style={[styles.base, this.state.dragging ? styles.active : styles.inactive]} onDragEnter={this.handleDragEnter} onDragOver={this.handleDragOver} onDragLeave={this.handleDragLeave} onDrop={this.handleDrop}>
        <h1 style={styles.heading}>{this.state.files.length ? this.state.files.map(file => { return file.name }).join(', ') : this.props.label}</h1>
      </section>
    )
  }
}

const styles = {
  base: {
    margin: '2em auto',
    borderSize: '.2em',
    borderStyle: 'dashed',
    borderRadius: '.4em',
    maxWidth: '24em',
    padding: '2em',
    textAlign: 'center',
    transition: '.25s'
  },
  inactive: {
    borderColor: '#fff'
  },
  active: {
    borderColor: '#000'
  },
  heading: {
    margin: 0,
    fontSize: 'inherit',
    pointerEvents: 'none'
  }
}



// WEBPACK FOOTER //
// src/components/file-drop-zone/index.js